import React from "react";
//#region types
//#endregion
//#region components
import { Grid, Skeleton } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TodoChipSkeleton: React.FC = (props) => {
  return (
    <Grid container className={cssExports.todoChipSkeleton}>
      <Grid container direction={"row"} columnGap={1}>
        <Skeleton width="12px" height="12px" />
        <Grid item xs>
          <Skeleton className={cssExports.titleIndicator} width="50%" height="8px" />
          <Skeleton width="33%" height="8px" />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TodoChipSkeleton;
